import { FunctionComponent } from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'
import type { OurIntlShape } from '@/i18n/typing'
import { Wrapper } from '@/utils/export-pptx/components/slides/styles'
import { PptxObjectType } from '@/utils/export-pptx/constants'
import type { HomeSlide } from '@/utils/export-pptx/types/slide'

interface SlideProps {
  slide: HomeSlide
  onSlideReady?: (slide: HomeSlide) => void
  formatMessage: OurIntlShape['formatMessage']
}

const SlideComponent: FunctionComponent<SlideProps> = ({
  slide,
  onSlideReady,
  formatMessage,
}) => {
  useMount(() => {
    onSlideReady?.(slide)
  })

  return (
    <Wrapper data-pptx-object={PptxObjectType.Shape}>
      <Container>
        <Type data-pptx-object={PptxObjectType.Text}>
          {formatMessage({ id: 'insight_report:slide_home_title' })}
        </Type>
        <Title data-pptx-object={PptxObjectType.Text}>
          {slide.payload.title}
        </Title>

        {slide.payload.description && (
          <Desc data-pptx-object={PptxObjectType.Text}>
            {slide.payload.description}
          </Desc>
        )}

        <AdditionalInfoBlock>
          <div data-pptx-object={PptxObjectType.Text}>
            {formatMessage({ id: 'general:field_cooperation_duration' })}
            {formatMessage({ id: 'general:colon' })}
            {slide.payload.period[0]} - {slide.payload.period[1]}
          </div>

          <Name data-pptx-object={PptxObjectType.Text}>
            {slide.payload.owner}
          </Name>
        </AdditionalInfoBlock>
      </Container>
    </Wrapper>
  )
}

const Container = styled.div`
  padding: 200px 120px 96px 120px;

  display: flex;
  flex-direction: column;

  height: 100%;
  width: 100%;
`

const Type = styled.div`
  margin-bottom: 4px;

  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 30px;
  line-height: 42px;
`

const Title = styled.div`
  margin-bottom: 20px;

  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 70px;
  font-weight: 700;
`

const Desc = styled.div`
  flex-grow: 1;

  color: ${({ theme }): string => theme.colors.text.secondary};
  font-size: 24px;
  line-height: 32px;
`

const AdditionalInfoBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  font-size: 20px;
`

const Name = styled.div`
  font-size: 28px;
  font-weight: 700;
`

export default SlideComponent
